import React, { useEffect, useState } from "react";

// core
import { API } from "../core/api";

// components
import { Header } from "../components/Header";
import { Loading } from "../components/Loading";
import { StaticCard } from "../components/StaticCard";
import { Note } from "../components/Note";

export const Home = () => {
  const [dashboard, setDashboard] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const getDashboard = () => {
    API.get
      .dashboard()
      .then((response) => {
        if (response.success) {
          setDashboard(response.data);
          setIsLoading(false);
        } else {
          Note.error(response.message);
          setIsLoading(false);
        }
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getDashboard();
  }, []);

  return (
    <>
      <Header title="پنل مدیریت" activeItem="dashboard" />
      <Loading isLoading={isLoading}>
        <div className="home-page">
          <div className="flex-row flex-content-space-around m-20">
            <StaticCard
              className="w-100 ml-20"
              name="کالا"
              value={dashboard.products_count}
            />
            <StaticCard
              className="w-100 ml-20"
              name="کالای فروشگاه"
              value={dashboard.seller_products_count}
            />
            <StaticCard
              className="w-100"
              name="شهر"
              value={dashboard.cities_count}
            />
          </div>
        </div>
      </Loading>
    </>
  );
};
